// // // import logo from './logo.svg';
// // // import './App.css';

// // // function App() {
// // //   return (
// // //     <div className="App">
// // //       <header className="App-header">
// // //         <img src={logo} className="App-logo" alt="logo" />
// // //         <p>
// // //           Edit <code>src/App.js</code> and save to reload.
// // //         </p>
// // //         <a
// // //           className="App-link"
// // //           href="https://reactjs.org"
// // //           target="_blank"
// // //           rel="noopener noreferrer"
// // //         >
// // //           Learn React
// // //         </a>
// // //       </header>
// // //     </div>
// // //   );
// // // }

// // // export default App;



// // // import React from 'react';
// // // import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
// // // import Home from './Pages/Home.js';
// // // import MessageSpinner from './Pages/MessageSpinner.js';
// // // import AvatarCreator from './Pages/AvatarCreator.js';
// // // import './App.css';

// // // export default function App() {
// // //   return (
// // //     <Router>
// // //       <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'sans-serif' }}>
// // //         <nav style={{ marginBottom: '30px', gap: '20px', display: 'flex', justifyContent: 'center' }}>
// // //           <Link to="/">Home</Link>
// // //           <Link to="/messages">Message Spinner</Link>
// // //           <Link to="/avatar">Create Avatar</Link>
// // //         </nav>
// // //         <Routes>
// // //           <Route path="/" element={<Home />} />
// // //           <Route path="/messages" element={<MessageSpinner />} />
// // //           <Route path="/avatar" element={<AvatarCreator />} />
// // //         </Routes>
// // //       </div>
// // //     </Router>
// // //   );
// // // }

// // // import React from 'react';
// // // import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// // // import Navbar from './components/Navbar';
// // // import Home from './Pages/Home';
// // // import MessageSpinner from './Pages/MessageSpinner';
// // // import AvatarCreator from './Pages/AvatarCreator';
// // // import './App.css';

// // // export default function App() {
// // //   return (
// // //     <Router>
// // //       <div className="app-container">
// // //         {/* Modular Navbar Component */}
// // //         {/* <Navbar /> */}

// // //         {/* PAGE CONTENT */}
// // //         <main className="main-content">
// // //           <Routes>
// // //             <Route path="/" element={<Home />} />
// // //             <Route path="/messages" element={<MessageSpinner />} />
// // //             <Route path="/avatar" element={<AvatarCreator />} />
// // //           </Routes>
// // //         </main>

// // //         <footer className="footer">
// // //           <p>🎉 Created with love for the best boss in the world! © 2026</p>
// // //         </footer>
// // //       </div>
// // //     </Router>
// // //   );
// // // }

// // import React from 'react';
// // import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// // import Navbar from './components/Navbar'; // Ensure this path matches where your Navbar.js is saved!
// // import Home from './Pages/Home';
// // import MessageSpinner from './Pages/MessageSpinner';
// // import AvatarCreator from './Pages/AvatarCreator';
// // import './App.css';

// // function App() {
// //   return (
// //     <Router>
// //       <div className="App" style={{ position: 'relative' }}>
        
// //         {/* ── THE GLOBAL NAVBAR ── 
// //             Mounted outside the Routes so it appears on every single page! */}
// //         <Navbar />
        
// //         {/* ── PAGE CONTENT ── */}
// //         <main>
// //           <Routes>
// //             <Route path="/" element={<Home />} />
// //             <Route path="/messages" element={<MessageSpinner />} />
// //             <Route path="/avatar" element={<AvatarCreator />} />
// //           </Routes>
// //         </main>
        
// //       </div>
// //     </Router>
// //   );
// // }

// // export default App;



// import React from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// import Navbar from './components/Navbar';
// import Home from './Pages/Home';
// import MessageSpinner from './Pages/MessageSpinner';
// import AvatarCreator from './Pages/AvatarCreator';
// import StaffRegistration from './Pages/StaffRegistration';
// import VerifyRegistration from './Pages/VerifyRegistration';
// import './App.css';
// import DignitaryInvitation from './Pages/DignitaryInvitation';
// import DignitaryAdmin from './Pages/DignitaryAdmin';
// import DignitaryList from './Pages/DignitaryList';
// import BirthdayCheckInScanner from './Pages/BirthdayCheckInScanner';
// import DignitarySuperMin from './Pages/DignitarySuperMin';
// function App() {
//   return (
//     <Router>
//       <div className="App" style={{ position: 'relative' }}>
//         <Navbar />

//         <main>
//           <Routes>
//             <Route path="/" element={<Home />} />
//             <Route path="/messages" element={<MessageSpinner />} />
//             <Route path="/avatar" element={<AvatarCreator />} />

//             {/* STAFF REGISTRATION */}
//             <Route
//               path="/registration"
//               element={<StaffRegistration />}
//             />
//             <Route
//   path="/verify/:registrationCode"
//   element={<VerifyRegistration />}
// />

// <Route
//   path="/vip/verify"
//   element={<DignitaryAdmin />}
// />

// <Route
//   path="/admin/verify"
//   element={<DignitarySuperMin />}
// />

// <Route
//   path="/invitation/:code"
//   element={<DignitaryInvitation />}
// />

// <Route
//   path="/admin/check-in"
//   element={
//     <BirthdayCheckInScanner />
//   }
// />

// <Route
//   path="/admin/dignitary-list"
//   element={<DignitaryList />}
// />
//           </Routes>
//         </main>
//       </div>
//     </Router>
//   );
// }

// export default App;






import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './Pages/Home';
import MessageSpinner from './Pages/MessageSpinner';
import AvatarCreator from './Pages/AvatarCreator';
import StaffRegistration from './Pages/StaffRegistration';
import VerifyRegistration from './Pages/VerifyRegistration';
import './App.css';
import DignitaryInvitation from './Pages/DignitaryInvitation';
import DignitaryAdmin from './Pages/DignitaryAdmin';
import DignitaryList from './Pages/DignitaryList';
import BirthdayCheckInScanner from './Pages/BirthdayCheckInScanner';
import DignitarySuperMin from './Pages/DignitarySuperMin';
function App() {
  return (
    <Router>
      <div className="App" style={{ position: 'relative' }}>
        <Navbar />

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/messages" element={<MessageSpinner />} />
            <Route path="/avatar" element={<AvatarCreator />} />

            {/* STAFF REGISTRATION */}
            <Route
              path="/registration"
              element={<StaffRegistration />}
            />
            <Route
  path="/verify/:registrationCode"
  element={<VerifyRegistration />}
/>

<Route
  path="/vip/verify"
  element={<DignitaryAdmin />}
/>

<Route
  path="/admin/verify"
  element={<DignitarySuperMin />}
/>

<Route
  path="/invitation/:code"
  element={<DignitaryInvitation />}
/>

<Route
  path="/admin/check-in"
  element={
    <BirthdayCheckInScanner />
  }
/>

<Route
  path="/admin/dignitary-list"
  element={<DignitaryList />}
/>
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
